import { decideVariantStyles, invertedVariantStyles, primaryVariantStyles, secondaryVariantStyles, tertiaryVariantStyles, toggleVariantStyles, } from './button-variants.styled';
export const getButtonVariantStyles = ({ variant }) => variant &&
    {
        primary: primaryVariantStyles,
        secondary: secondaryVariantStyles,
        tertiary: tertiaryVariantStyles,
        decide: decideVariantStyles,
        icon: null,
        toggle: toggleVariantStyles,
    }[variant];
export const getButtonVisualVariantStyles = ({ visualStyle, }) => visualStyle &&
    {
        primary: primaryVariantStyles,
        secondary: secondaryVariantStyles,
        inverted: invertedVariantStyles,
        decide: decideVariantStyles,
    }[visualStyle];
//# sourceMappingURL=helpers.js.map